import { useState } from "react";
import { INPUT, BTN, when, leadText } from "@/components/ManualConfirmParts";

const Field = ({ label, children }) => (
  <label className="flex flex-col gap-1.5">
    <span className="text-[10px] font-mono uppercase tracking-widest text-atlas-secondary">{label}</span>
    {children}
  </label>
);

const verdict = (c, iso) => {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  const lead = (t - new Date(c.predicted_at).getTime()) / 3.6e6;
  if (lead <= 0) return { ok: false, text: "Issued before the flag: no lead time, cannot be a hit" };
  if (t > new Date(c.late_until).getTime()) return { ok: false, text: `After the last allowed time (${when(c.late_until)})` };
  const late = t > new Date(c.final_at).getTime();
  return { ok: true, text: `Lead ${leadText(lead)} · will score as ${late ? "Confirmed (late)" : "Confirmed (hit)"}` };
};

export const ManualConfirmForm = ({ c, onSubmit, busy }) => {
  const [f, setF] = useState({ agency: "", title: "", issued: "", link: "", note: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const iso = f.issued ? `${f.issued}:00Z` : "";
  const v = verdict(c, iso);
  const ready = f.agency.trim() && f.title.trim() && v?.ok && !busy;
  return (
    <form className="flex flex-col gap-4" data-testid="manual-confirm-form"
      onSubmit={(e) => { e.preventDefault(); if (ready) onSubmit({ agency: f.agency, title: f.title, issued_at: iso, link: f.link, note: f.note }); }}>
      <div className="border border-white/10 bg-atlas-void/40 p-3 text-[11px] font-mono" data-testid="manual-selected">
        <div className="text-white">{c.region}</div>
        <div className="text-atlas-secondary">flagged {when(c.predicted_at)} · confirmations accepted until {when(c.late_until)}</div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Agency"><input className={INPUT} value={f.agency} onChange={set("agency")} placeholder="e.g. INSIVUMEH" data-testid="manual-agency-input" /></Field>
        <Field label="Issued at (UTC)"><input type="datetime-local" className={INPUT} value={f.issued} onChange={set("issued")} data-testid="manual-issued-input" /></Field>
      </div>
      <Field label="Warning title"><input className={INPUT} value={f.title} onChange={set("title")} placeholder="e.g. Landslide WARNING — Sierra Madre" data-testid="manual-title-input" /></Field>
      <Field label="Link to the official warning (optional)"><input className={INPUT} value={f.link} onChange={set("link")} placeholder="https://" data-testid="manual-link-input" /></Field>
      <Field label="Reviewer note (optional)"><input className={INPUT} value={f.note} onChange={set("note")} data-testid="manual-note-input" /></Field>
      {v && <p className={`text-[11px] font-mono ${v.ok ? "text-emerald-400" : "text-atlas-red"}`} data-testid="manual-verdict">{v.text}</p>}
      <button className={`${BTN} border-emerald-400/60 text-emerald-300 hover:bg-emerald-400/10 self-start`} disabled={!ready} data-testid="manual-submit">
        {busy ? "Logging…" : "Log confirmed hit"}
      </button>
    </form>
  );
};
